<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">Godchildren</span></p>
<p class="center"><img alt="" src="OEBPS/images/9780312382582_clogo1.png"/></p>
<p class="center"><span class="big2">Nicholas Coleridge</span><br/><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780312382582_L01.png"/></p>
<p class="center"><span class="small">THOMAS DUNNE BOOKS</span><br/><span class="small">St. Martin’s Press</span><br/><span class="small">NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312382582_epub_tp_r1.vue?a6e39e02